import * as imagesLoaded from 'imagesloaded'
import Lenis from 'lenis'
import 'lenis/dist/lenis.css'
import gsap from 'gsap'
import { TweenMax, Power2 } from 'gsap'
import { ScrollTrigger } from "gsap/ScrollTrigger"
import common from './common'
import index from './index'
import eAccess from './e-access'
import eIndex from './e-index'
import partials from './partials'

gsap.registerPlugin(ScrollTrigger)

document.addEventListener('DOMContentLoaded', function() {
  partials().then(() => {
    imagesLoaded(document.getElementById('app'), () => {
      event()
      initContactForm()
    })
  })
})

function event() {
  common()
  index()
  eAccess()
  eIndex()
  require("fslightbox")
}


function initContactForm() {
  setTimeout(()=>{
    const cf_selector = 'div.wpcf7 > form'
    const cf_forms = document.querySelectorAll(cf_selector)
    
    if (cf_forms.length > 0) {
      const cf_load = document.querySelector('.wpcf7-spinner')
      cf_load.remove()
      window.wpcf7.init(cf_forms[0])
    }
  },1000)
}



